import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { useLanguage } from "../helpers/LanguageContext";
import ScriptEditor from "./scriptsPage/ScriptEditor";
import ScriptsList from "./scriptsPage/ScriptsList";
import useScriptsListController from "./scriptsPage/useScriptsListController";

export default function ScriptsPage() {
  const { scriptId } = useParams();
  const navigate = useNavigate();
  const scripts = useSelector((state) => state.scripts || []);
  const { t } = useLanguage();
  const [isCreating, setIsCreating] = useState(false);

  const openCreateEditor = useCallback(() => setIsCreating(true), []);
  const closeEditor = useCallback(() => {
    setIsCreating(false);
    if (scriptId) navigate("/scripts");
  }, [navigate, scriptId]);

  const scriptListController = useScriptsListController({
    onCreate: openCreateEditor
  });

  if (scriptId || isCreating) {
    return <ScriptEditor onClose={closeEditor} />;
  }

  return (
    <div className="container">
      <h1>{t("scripts")}</h1>
      <ScriptsList
        scripts={scripts}
        t={t}
        onCreate={scriptListController.handleCreate}
        onEdit={scriptListController.handleEdit}
        onDuplicate={scriptListController.handleDuplicate}
        onDelete={scriptListController.handleDelete}
      />
    </div>
  );
}
